import StatusPill from './status_pill';

export default StatusPill;
